import { Heading, Stack, Text } from '@etg/wings';
import { useSiteContext, useTranslation } from '@eti/providers';
import { PartOfExternalFlights } from '@eti/schema-types';
import { useOrderDetails } from '../../../../containers/OrderDetailsContext';
import { isCheckInProductAvailableToBuy } from './utils';
import PurchaseOption from './PurchaseOption';
import SelfCheckin from './self-checkin/SelfCheckin';
import { APP, SERVICE } from './purchaseOptionConstants';

const NotPurchasedCheckIn = () => {
  const { t } = useTranslation();
  const { agencyAccount } = useSiteContext();
  const { availableExtraProducts, isVI, isWhiteLabelBrand, partOfExternalFlights } =
    useOrderDetails();
  const isCheckInAvailableToBuy =
    availableExtraProducts && isCheckInProductAvailableToBuy(availableExtraProducts);
  const notPurchasedDescription = isVI
    ? t('OrderDetails.CheckIn.NotPurchased.VI.Description')
    : t('OrderDetails.CheckIn.NotPurchased.Description');

  return (
    <Stack data-testid="not-purchased-checkin">
      <Stack>
        <Stack spacing={8}>
          <Heading as="h2" level={3}>
            {t('OrderDetails.CheckIn.NotPurchased.Title')}
          </Heading>
          <Text asHtml>{notPurchasedDescription}</Text>
        </Stack>
        <Stack spacing={8}>
          <Heading as="h3" level={4}>
            {t('OrderDetails.CheckIn.BoardingPasses.Title')}
          </Heading>
          <Text>{t('OrderDetails.CheckIn.BoardingPasses.Description')}</Text>
        </Stack>
      </Stack>
      <Heading as="h2" level={3}>
        {t('OrderDetails.CheckIn.Options.Title')}
      </Heading>
      <Stack spacing={8}>
        {isCheckInAvailableToBuy && partOfExternalFlights !== PartOfExternalFlights.All && (
          <>
            {!isWhiteLabelBrand && !agencyAccount && (
              <PurchaseOption iconName="app-checkin" type={APP} />
            )}
            <PurchaseOption iconName="check-in" type={SERVICE} />
          </>
        )}
        <SelfCheckin isInitiallyOpen={!isCheckInAvailableToBuy} />
      </Stack>
    </Stack>
  );
};

export default NotPurchasedCheckIn;
